// extracted by mini-css-extract-plugin
export default {"Wrapper":"_Wrapper--oTtvz","Disabled":"_Disabled--u8ZwK","Toggle":"_Toggle--LAAlq"};